import { SceneDefinition } from '../types';

export const SCENES: SceneDefinition[] = [
  // ═══════════════════════════════════════════════════
  // 주의가 필요한 행동 시나리오 (판정 아님, 감지만)
  // ═══════════════════════════════════════════════════

  // ── 옆보기 관련 ──
  {
    id: 'side_copy',
    pattern: ['LOOKING_SIDE', 'RETURNED', 'BURST_TYPING'],
    severity: 'CRITICAL',
    label: '옆을 보다가 작성 시작',
    desc: '옆을 보다가 돌아와서 답을 쓰기 시작',
    icon: '🔴',
    minHoldMs: 400,
    maxGapMs: 5000,
    maxInterveningStates: 1,
  },
  {
    id: 'side_copy_write',
    pattern: ['LOOKING_SIDE', 'RETURNED', 'WRITING_NORMAL'],
    severity: 'WARNING',
    label: '옆 보고 작성 (키보드/필기)',
    desc: '옆을 보다가 돌아와서 바로 작성 시작 (키보드 또는 스타일러스)',
    icon: '🟡',
    minHoldMs: 500,
    maxGapMs: 5000,
    maxInterveningStates: 1,
  },
  {
    id: 'repeated_glance',
    pattern: ['LOOKING_SIDE', 'FOCUSED', 'LOOKING_SIDE'],
    severity: 'WARNING',
    label: '옆 반복 응시 (2회)',
    desc: '옆을 반복적으로 확인',
    icon: '🟡',
    minHoldMs: 300,       // 낮춤: 짧은 옆 응시도 감지
    maxGapMs: 10000,      // 10초 이내 2회
    maxInterveningStates: 3,  // 중간에 다른 상태 허용 (RETURNED 등)
  },
  {
    id: 'repeated_glance_3',
    pattern: ['LOOKING_SIDE', 'FOCUSED', 'LOOKING_SIDE', 'FOCUSED', 'LOOKING_SIDE'],
    severity: 'CRITICAL',
    label: '옆 반복 응시 (3회)',
    desc: '짧은 시간 내 3회 이상 옆을 반복 확인',
    icon: '🔴',
    minHoldMs: 250,
    maxGapMs: 12000,
    maxInterveningStates: 3,
  },

  // ── 아래보기 관련 ──
  {
    id: 'memo_ref',
    pattern: ['LOOKING_DOWN', 'RETURNED', 'BURST_TYPING'],
    severity: 'WARNING',
    label: '아래를 보다가 작성 시작',
    desc: '아래를 보다가 돌아와서 답을 쓰기 시작',
    icon: '🟡',
    minHoldMs: 400,
    maxGapMs: 4000,
    maxInterveningStates: 1,
  },
  {
    id: 'memo_ref_write',
    pattern: ['LOOKING_DOWN', 'RETURNED', 'WRITING_NORMAL'],
    severity: 'WARNING',
    label: '아래 보고 작성',
    desc: '아래를 보다가 돌아와서 바로 작성 시작',
    icon: '🟡',
    minHoldMs: 500,
    maxGapMs: 5000,
    maxInterveningStates: 1,
  },
  {
    id: 'watch_ref',
    pattern: ['LOOKING_DOWN', 'RETURNED', 'LOOKING_DOWN', 'BURST_TYPING'],
    severity: 'CRITICAL',
    label: '손목·아래 반복 주시 후 작성',
    desc: '손목/아래를 반복 주시 후 답을 쓰기 시작',
    icon: '🔴',
    minHoldMs: 300,
    maxGapMs: 6000,
    maxInterveningStates: 2,
  },
  {
    id: 'watch_ref_write',
    pattern: ['LOOKING_DOWN', 'RETURNED', 'LOOKING_DOWN', 'WRITING_NORMAL'],
    severity: 'WARNING',
    label: '손목·아래 반복 주시 후 작성 (입력)',
    desc: '손목/아래를 반복 주시 후 작성',
    icon: '🟡',
    minHoldMs: 300,
    maxGapMs: 6000,
    maxInterveningStates: 2,
  },

  // ── 음성 관련 ──
  {
    id: 'answer_heard',
    pattern: ['LISTENING', 'RETURNED', 'BURST_TYPING'],
    severity: 'CRITICAL',
    label: '음성 감지 후 작성 시작',
    desc: '음성 감지 후 돌아와서 답을 쓰기 시작',
    icon: '🔴',
    minHoldMs: 300,
    maxGapMs: 6000,
    maxInterveningStates: 2,
  },
  {
    id: 'answer_write',
    pattern: ['LISTENING', 'RETURNED', 'WRITING_NORMAL'],
    severity: 'WARNING',
    label: '음성 후 작성',
    desc: '음성 감지 후 돌아와서 바로 작성 시작',
    icon: '🟡',
    minHoldMs: 300,
    maxGapMs: 5000,
    maxInterveningStates: 2,
  },
  {
    id: 'short_talk_write',
    pattern: ['LISTENING', 'BURST_TYPING'],
    severity: 'WARNING',
    label: '짧은 대화 후 작성',
    desc: '짧은 음성 감지 후 바로 답을 쓰기 시작',
    icon: '🟡',
    minHoldMs: 300,
    maxGapMs: 3000,
    maxInterveningStates: 1,
    minConfidence: 0.5,
  },
  {
    id: 'whisper_input',
    pattern: ['LISTENING', 'FOCUSED', 'BURST_TYPING'],
    severity: 'WARNING',
    label: '짧은 음성 후 정면 보고 작성',
    desc: '짧은 음성 감지 후 정면을 보고 답을 쓰기 시작',
    icon: '🟡',
    minHoldMs: 300,
    maxGapMs: 6000,
    maxInterveningStates: 2,
  },
  {
    id: 'remote_assist',
    pattern: ['LISTENING', 'LOOKING_SIDE', 'BURST_TYPING'],
    severity: 'CRITICAL',
    label: '음성·시선 이동·빠른 입력 동시',
    desc: '외부 음성 + 시선 이동 + 빠른 입력',
    icon: '🔴',
    minHoldMs: 300,
    maxGapMs: 8000,
    maxInterveningStates: 2,
  },
  {
    id: 'remote_assist_write',
    pattern: ['LISTENING', 'LOOKING_SIDE', 'WRITING_NORMAL'],
    severity: 'WARNING',
    label: '음성·시선 이동 후 작성',
    desc: '외부 음성 + 시선 이동 + 작성',
    icon: '🟡',
    minHoldMs: 300,
    maxGapMs: 8000,
    maxInterveningStates: 2,
  },

  // ── 카메라/기타 ──
  {
    id: 'camera_block',
    pattern: ['GAZING_OUT', 'IDLE'],
    severity: 'CRITICAL',
    label: '갑작스런 시선 이탈 + 입력 정지',
    desc: '갑작스런 시선 이탈 + 입력 정지',
    icon: '🔴',
    minHoldMs: 2000,
    maxGapMs: 3000,
    maxInterveningStates: 0,
    minSpanMs: 3000,
    minConfidence: 0.6,
  },

  // ═══════════════════════════════════════════════════
  // 정상 시나리오
  // ═══════════════════════════════════════════════════
  {
    id: 'air_thinking',
    pattern: ['THINKING_UP', 'RETURNED', 'WRITING_NORMAL'],
    severity: 'NORMAL',
    label: '생각 후 작성',
    desc: '위를 보며 생각한 뒤 정상 속도로 작성',
    icon: '🟢',
    minHoldMs: 300,
    maxGapMs: 8000,
    maxInterveningStates: 2,
  },
  {
    id: 'rest_resume',
    pattern: ['GAZING_OUT', 'FOCUSED', 'WRITING_NORMAL'],
    severity: 'NORMAL',
    label: '잠깐 쉬고 재개',
    desc: '잠시 쉰 뒤 다시 집중해서 작성',
    icon: '🟢',
    minHoldMs: 500,
    maxGapMs: 10000,
    maxInterveningStates: 2,
  },
  {
    id: 'slow_think',
    pattern: ['THINKING_UP', 'SLOW_TYPING'],
    severity: 'NORMAL',
    label: '고민하며 천천히',
    desc: '생각하며 천천히 작성 중',
    icon: '🟢',
    minHoldMs: 500,
    maxGapMs: 5000,
    maxInterveningStates: 1,
  },
  {
    id: 'read_focus',
    pattern: ['FOCUSED', 'THINKING_UP', 'FOCUSED', 'THINKING_UP', 'FOCUSED'],
    severity: 'NORMAL',
    label: '문제 꼼꼼히 읽기',
    desc: '화면과 위(생각)를 오가며 문제를 읽고 생각하는 중',
    icon: '🟢',
    minHoldMs: 250,
    maxGapMs: 10000,
    maxInterveningStates: 1,
  },
  {
    id: 'stretch_resume',
    pattern: ['GAZING_OUT', 'RETURNED', 'WRITING_NORMAL'],
    severity: 'NORMAL',
    label: '스트레칭 후 재개',
    desc: '잠시 자세를 바꾸거나 스트레칭 후 정상 복귀',
    icon: '🟢',
    minHoldMs: 300,
    maxGapMs: 8000,
    maxInterveningStates: 2,
  },
  {
    id: 'steady_focus',
    pattern: ['FOCUSED', 'WRITING_NORMAL', 'FOCUSED', 'WRITING_NORMAL'],
    severity: 'NORMAL',
    label: '안정적 집중',
    desc: '정면 집중과 정상 속도 입력이 꾸준히 반복',
    icon: '🟢',
    minHoldMs: 1500,
    maxGapMs: 10000,
    maxInterveningStates: 1,
    minSpanMs: 6000,
  },

  // ═══════════════════════════════════════════════════
  // 행동 패턴 시나리오
  // ═══════════════════════════════════════════════════
  {
    id: 'frustrated_input',
    pattern: ['IDLE', 'BURST_TYPING', 'IDLE', 'BURST_TYPING'],
    severity: 'WARNING',
    label: '멈춤·급타 반복 입력',
    desc: '멈춤-급타-멈춤-급타 반복',
    icon: '🟠',
    minHoldMs: 300,
    maxGapMs: 6000,
    maxInterveningStates: 1,
    minSpanMs: 3000,
  },
  {
    id: 'give_up_idle',
    pattern: ['GAZING_OUT', 'FOCUSED', 'GAZING_OUT', 'FOCUSED', 'GAZING_OUT'],
    severity: 'WARNING',
    label: '입력 없이 먼 곳 응시 반복',
    desc: '먼 곳 주시 + 정면 반복, 입력 없음',
    icon: '🟠',
    minHoldMs: 800,
    maxGapMs: 10000,
    maxInterveningStates: 1,
    minSpanMs: 8000,
  },
  {
    id: 'panic_typing',
    pattern: ['BURST_TYPING', 'LOOKING_SIDE', 'BURST_TYPING'],
    severity: 'WARNING',
    label: '입력 중 옆 확인 후 재입력',
    desc: '입력 중 옆을 확인한 뒤 다시 입력',
    icon: '🟠',
    minHoldMs: 250,
    maxGapMs: 5000,
    maxInterveningStates: 1,
  },
];
